import * as ConfigAPI from "../api/config";
import { type ConfigResponse } from "../api/config";
import * as DummyConfigAPI from "../dummyApi/config";
import { isDemoMode } from "../stores/mode";

interface ConfigAPI {
  getConfig: (domain: string) => Promise<ConfigResponse>;
}

const getAPI = (): ConfigAPI => {
  return isDemoMode() ? DummyConfigAPI : ConfigAPI;
};

export const getConfig = async (domain: string): Promise<ConfigResponse> => {
  return getAPI().getConfig(domain);
};
